import React, { useEffect, useState, useContext } from "react";
import { Grid, Typography, Button, Box, TextField, Input, Autocomplete, Modal, CircularProgress, Skeleton, listClasses } from "@mui/material";
import { useTranslation } from "react-i18next";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import Resizer from "react-image-file-resizer";
import AlertMessage from "./modules/AlertMessage";
import { baseUrl } from "./modules/general";
import axios from "axios";
import { useParams } from 'react-router-dom';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { NavLink, } from "react-router-dom";

let imageFile = "";
export default function EditProductFaetures() {
  const { t, i18n } = useTranslation();
  const [alert, setAlert] = useState({ alertCheck: false, message: "", severity: "" });
  const { id, mode } = useParams();
  const [oldData, setOldData] = useState({
    group: "",
    groupID: "",
    brand: "",
    brandID: "",
    model: "",
    modelID: "",
    region: "",
    regionID: "",
    size: "",
    sizeID: "",
    color: "",
    colorID: "",
    os: "",
    process: "",
    network: "",
    year: "",
    weight: "",
    sim: "",
    display: "",
    ram: "",
    zarfiat: "",
    graphic: "",
    mainCameraFeature: "",
    mainCameraResolution: "",
    mainCameraVideo: "",
    selfiCameraFeature: "",
    selfiCameraResolution: "",
    selfiCameraVideo: "",
    battery: "",
    charge: "",
    price: "",
    title_en: "",
    title_fa: "",
    description: "",
    h1_en: "",
    h1_fa: "",
    desc_en: "",
    desc_fa: "",
    keyword_fa: "",
    keyword_en: "",
    img1: null,
    img2: null,
    img3: null,
    img4: null,
    img1ID: "",
    img2ID: "",
    img3ID: "",
    img4ID: "",
  })
  const [modelData, setModelData] = useState(null);
  const [brandData, setBrandData] = useState(null);
  const [groupData, setGroupData] = useState(null);
  const [regionData, setRegionData] = useState(null);
  const [sizeData, setSizeData] = useState(null);
  const [colorData, setColorData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [proDis, setProDis] = useState(false);

  useEffect(() => {
    getProductData()
  }, [])


  const getProductData = () => {
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/get',
      method: "GET",
      params: {
        prop: "P",
        id: id
      },
    }))
      .then((res) => {
        const productData = res.data.data;
        if (productData.length > 0) {
          const item = productData[0];

          setOldData({
            group: item.group?.name_fa || "",
            groupID: item.group?.id || "",
            brand: item.brand?.name_fa || "",
            brandID: item.brand?.id || "",
            model: item.model?.name || "",
            modelID: item.model?.id || "",
            region: item.regin?.name_fa || "",
            regionID: item.regin?.id || "",
            size: `${item.size?.inch || ''}_${item.size?.pixel || ''}`,
            sizeID: item.size?.id || "",
            color: item.color?.name_fa || "",
            colorID: item.color?.id || "",
            os: item.os || "",
            process: item.proccess || "",
            network: item.network || "",
            year: item.lunch || "",
            weight: item.weight || "",
            sim: item.sim || "",
            display: item.type_display || "",
            ram: item.ram || "",
            zarfiat: item.hdd || "",
            graphic: item.vga || "",
            mainCameraFeature: item.main_camera_fea || "",
            mainCameraResolution: item.main_camera_mou || "",
            mainCameraVideo: item.main_camera_vid || "",
            selfiCameraFeature: item.selfi_camera_fea || "",
            selfiCameraResolution: item.selfi_camera_mou || "",
            selfiCameraVideo: item.selfi_camera_vid || "",
            battery: item.battery || "",
            charge: item.charging || "",
            price: item.price || "",
            title_en: item.title_en || "",
            title_fa: item.title_fa || "",
            description: item.des || "",
            h1_en: item.h1_en || "",
            h1_fa: item.h1_fa || "",
            desc_en: item.des_seo_en || "",
            desc_fa: item.des_seo_fa || "",
            keyword_fa: item.key_fa || "",
            keyword_en: item.key_en || "",
            img1: item.image.length >= 1 ? item.image[0].path : null,
            img2: item.image.length >= 2 ? item.image[1].path : null,
            img3: item.image.length >= 3 ? item.image[2].path : null,
            img4: item.image.length >= 4 ? item.image[3].path : null,
            img1ID: item.image.length >= 1 ? item.image[0].id : "",
            img2ID: item.image.length >= 2 ? item.image[1].id : "",
            img3ID: item.image.length >= 3 ? item.image[2].id : "",
            img4ID: item.image.length >= 4 ? item.image[3].id : "",
          });
        }
      })
      .catch((error) => {
        const { status } = error.response;
        status === 500 ?
          setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" }) :
          setAlert({ alertCheck: true, message: t("alert_dataFaild"), severity: "error" })
      })
  }

  useEffect(() => {
    const props = ["M", "B", "G", "R", "S", "C"];
    props.forEach(prop => {
      getProductOldData(prop);
    });
  }, []);

  const getProductOldData = (prp) => {
    const AuthStr = 'bearer ' + (localStorage.getItem('TACC'));
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/get',
      method: "GET",
      params: {
        prop: prp
      },
      headers: { 'Authorization': AuthStr },
    }))
      .then((res) => {
        switch (prp) {
          case ("M"):
            setModelData(res.data.data)
            break;
          case ("B"):
            setBrandData(res.data.data)
            break;
          case ("G"):
            setGroupData(res.data.data)
            break;
          case ("R"):
            setRegionData(res.data.data)
            break;
          case ("S"):
            setSizeData(res.data.data)
            break;
          case ("C"):
            setColorData(res.data.data)
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        const { status } = error.response;
        status === 500 ?
          setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" }) :
          setAlert({ alertCheck: true, message: t("alert_dataFaild"), severity: "error" })
      })
  }

  const onchangeGroup = (event, newSelection) => {
    setOldData(prevState => ({
      ...prevState,
      group: newSelection?.value || "",
      groupID: newSelection?.id || "",
    }));
  }

  const onchangeBrand = (event, newSelection) => {
    setOldData(prevState => ({
      ...prevState,
      brand: newSelection?.value || "",
      brandID: newSelection?.id || "",
    }));
  }

  const onchangeModel = (event, newSelection) => {
    setOldData(prevState => ({
      ...prevState,
      model: newSelection?.value || "",
      modelID: newSelection?.id || "",
    }));
  }

  const onchangeRegion = (event, newSelection) => {
    setOldData(prevState => ({
      ...prevState,
      region: newSelection?.value || "",
      regionID: newSelection?.id || "",
    }));
  }

  const onchangeSize = (event, newSelection) => {
    setOldData(prevState => ({
      ...prevState,
      size: newSelection?.value || "",
      sizeID: newSelection?.id || "",
    }));
  }

  const onchangeColor = (event, newSelection) => {
    setOldData(prevState => ({
      ...prevState,
      color: newSelection?.value || "",
      colorID: newSelection?.id || "",
    }));
  }

  const brandSelect = brandData === null ? [] : brandData.map((item) => (
    {
      value: i18n.language === "fa" ? item.name_fa : item.en,
      id: item.id
    }
  ))

  const groupSelect = groupData === null ? [] : groupData.map((item) => (
    {
      value: i18n.language === "fa" ? item.name_fa : item.en,
      id: item.id
    }
  ))

  const modelSelect = modelData === null ? [] : modelData.map((item) => (
    {
      value: item.name,
      id: item.id
    }
  ))

  const regionSelect = regionData === null ? [] : regionData.map((item) => (
    {
      value: i18n.language === "fa" ? item.name_fa : item.en,
      id: item.id
    }
  ))

  const sizeSelect = sizeData === null ? [] : sizeData.map((item) => (
    {
      value: `${item.inch}_${item.pixel}`,
      id: item.id
    }
  ))

  const colorSelect = colorData === null ? [] : colorData.map((item) => (
    {
      value: i18n.language === "fa" ? item.name_fa : item.en,
      id: item.id
    }
  ))

  const addProduct = () => {
    setLoading(true);
    setProDis(true);
    const formData = new FormData();
    if (oldData.groupID !== "") { formData.append("group", oldData.groupID) };
    if (oldData.modelID !== "") { formData.append("model", oldData.modelID) };
    if (oldData.brandID !== "") { formData.append("brand", oldData.brandID) };
    if (oldData.regionID !== "") { formData.append("regin", oldData.regionID) };
    if (oldData.colorID !== "") { formData.append("color", oldData.colorID) };
    if (oldData.sizeID !== "") { formData.append("size", oldData.sizeID) };
    if (oldData.process !== "") { formData.append("proccess", oldData.process) };
    if (oldData.os !== "") { formData.append("os", oldData.os) };
    if (oldData.network !== "") { formData.append("network", oldData.network) };
    if (oldData.year !== "") { formData.append("lunch", oldData.year) };
    if (oldData.weight !== "") { formData.append("weight", oldData.weight) };
    if (oldData.sim !== "") { formData.append("sim", oldData.sim) };
    if (oldData.display !== "") { formData.append("type_display", oldData.display) };
    if (oldData.ram !== "") { formData.append("ram", oldData.ram) };
    if (oldData.zarfiat !== "") { formData.append("hdd", oldData.zarfiat) };
    if (oldData.graphic !== "") { formData.append("vga", oldData.graphic) };
    if (oldData.mainCameraResolution !== "") { formData.append("main_camera_mou", oldData.mainCameraResolution) };
    if (oldData.mainCameraFeature !== "") { formData.append("main_camera_fea", oldData.mainCameraFeature) };
    if (oldData.mainCameraVideo !== "") { formData.append("main_camera_vid", oldData.mainCameraVideo) };
    if (oldData.selfiCameraResolution !== "") { formData.append("selfi_camera_mou", oldData.selfiCameraResolution) };
    if (oldData.selfiCameraFeature !== "") { formData.append("selfi_camera_fea", oldData.selfiCameraFeature) };
    if (oldData.selfiCameraVideo !== "") { formData.append("selfi_camera_vid", oldData.selfiCameraVideo) };
    if (oldData.battery !== "") { formData.append("battery", oldData.battery) };
    if (oldData.charge !== "") { formData.append("charging", oldData.charge) };
    if (oldData.price !== "") { formData.append("price", oldData.price) };
    if (oldData.title_fa !== "") { formData.append("title_fa", oldData.title_fa) };
    if (oldData.title_en !== "") { formData.append("title_en", oldData.title_en) };
    if (oldData.description !== "") { formData.append("des", oldData.description) };
    if (oldData.h1_en !== "") { formData.append("h1_en", oldData.h1_en) };
    if (oldData.h1_fa !== "") { formData.append("h1_fa", oldData.h1_fa) };
    if (oldData.desc_en !== "") { formData.append("des_seo_en", oldData.desc_en) };
    if (oldData.desc_fa !== "") { formData.append("des_seo_fa", oldData.desc_fa) };
    if (oldData.keyword_en !== "") { formData.append("key_en", oldData.keyword_en) };
    if (oldData.keyword_fa !== "") { formData.append("key_fa", oldData.keyword_fa) };
    formData.append("prop", "P");
    formData.append("id", id);

    const AuthStr = 'bearer ' + (localStorage.getItem('TACC'));
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/edit',
      method: "POST",
      headers: {
        'Authorization': AuthStr,
        'Content-Type': 'multipart/form-data',
      },
      data: formData
    }))
      .then((res) => {
        setProDis(false)
        setLoading(false)
        setAlert({ alertCheck: true, message: "ویرایش شد", severity: "success" })
        const timeout = setTimeout(() => {
          getProductData()
        }, 2000)
        return () => {
          clearTimeout(timeout)
        };
      })
      .catch(
        (error) => {
          const { status } = error.response;
          switch (status) {
            case (500):
              setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" })
              break;
            case (400):
              setAlert({ alertCheck: true, message: "درخواست نامعتبر است،لطفا فیلدها را مجددا چک کنید", severity: "error" })
              break;
            default:
              setAlert({ alertCheck: true, message: t("alert_defualt"), severity: "error" })
          }
          setProDis(false)
          setLoading(false)
        })
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    return setAlert({ alertCheck: false, message: "", severity: alert.severity })
  };

  const deleteImage = (img) => {
    setLoading(true);
    setProDis(true);
    let data = {
      id: img === "I1" ? oldData.img1ID : img === "I2" ? oldData.img2ID : img === "I3" ? oldData.img3ID : img === "I4" && (oldData.img4ID),
      mode: "D",
      prop: "I"
    }
    const AuthStr = 'bearer ' + (localStorage.getItem('TACC'));
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/edit',
      method: "POST",
      headers: {
        'Authorization': AuthStr,
      },
      data: data
    }))
      .then((res) => {
        setProDis(false)
        setLoading(false)
        getProductData()
      })
      .catch(
        (error) => {
          const { status } = error.response;
          switch (status) {
            case (500):
              setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" })
              break;
            case (400):
              setAlert({ alertCheck: true, message: "درخواست نامعتبر است", severity: "error" })
              break;
            default:
              setAlert({ alertCheck: true, message: t("alert_defualt"), severity: "error" })
          }
          setProDis(false)
          setLoading(false)
        })
  }

  const onChangeLicence = (e, IMG) => {
    if (e.target.files[0]) {
      imageFile = e.target.files[0];
      if (imageFile.size > 1000000) {
        setAlert({ alertCheck: true, message: t("alert_picSize"), severity: "error" })
      }
      else {
        imageResizer(IMG)
      }
    }
  };

  const imageResizer = (data) => {
    try {
      Resizer.imageFileResizer(
        imageFile,
        870,
        580,
        "JPEG",
        100,
        0,
        (uri) => {
          let reader = new FileReader();
          reader.readAsDataURL(uri);
          data === "IMG1" ? sendImage(uri) : data === "IMG2" ? sendImage(uri) : data === "IMG3" ? sendImage(uri) : data === "IMG4" && sendImage(uri)
        },
        "file",
      );
    } catch (err) {
      setAlert({ alertCheck: true, message: t("alert_notPic"), severity: "error" })
    }
  };

  const sendImage = (img) => {
    setLoading(true);
    const AuthStr = 'Bearer ' + (localStorage.getItem('TACC'));
    const formData = new FormData();
    formData.append("prop", "I");
    formData.append("product_id", id);
    formData.append("image", img);
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/set',
      method: "POST",
      headers: {
        'Authorization': AuthStr,
        'Content-Type': 'multipart/form-data',
      },
      data: formData
    }))
      .then((res) => {
        setLoading(false)
        getProductData()
      })
      .catch(
        (error) => {
          const { status } = error.response;
          switch (status) {
            case (500):
              setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" })
              break;
            case (400):
              setAlert({ alertCheck: true, message: "درخواست نامعتبر است", severity: "error" })
              break;
            default:
              setAlert({ alertCheck: true, message: t("alert_defualt"), severity: "error" })
          }
          setLoading(false)
        })
  }

  const replaceNumber = (value, la) => {
    value = value ? value.toString() : '';
    if (la === "fa") {
      value = value.replace(".", "/");
    }
    return value;
  }

  const separator = (value) => {
    value = value ? value.toString() : '';
    var place = 0;
    if (value.includes(".")) {
      place = value.indexOf(".");
      var num1 = value.slice(0, place);
      var num2 = value.slice(place + 1, value.length);
      value = camaInsert(num1, false) + "." + camaInsert(num2, true);
    }
    else {
      value = camaInsert(value);
    }
    return value;
  }

  function camaInsert(value, after = false) {
    var output = [];
    var outputString = "";
    if (after) {
      for (var i = 1; i <= value.length; i++) {
        if (i % 3 === 0) {
          output.push(value.slice(i - 3, i))
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(value.length - value.length % 3, value.length))
      }

      for (var j = 0; j < output.length; j++) {
        if (j + 1 < output.length) {
          outputString = outputString + output[j] + ",";
        }
        else {
          outputString = outputString + output[j];
        }
      }
    }
    else {
      for (var p = 1; p <= value.length; p++) {
        if (p % 3 === 0) {
          output.push(value.slice(value.length - p, value.length - p + 3))
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(0, value.length % 3))
      }
      for (var o = output.length - 1; o >= 0; o--) {
        if (o > 0) {
          outputString = outputString + output[o] + ",";
        }
        else {
          outputString = outputString + output[o];
        }
      }
    }
    return outputString;
  }

  const stringValue = (value) => {
    var output = "";
    value = value.toString();
    value = value.split(",");
    for (var i = 0; i < value.length; i++) {
      output += value[i].toString();
    }
    output = output.replace("/", ".");
    return output;
  }

  const onlyFloatnaumber = (value) => {
    value = value.trim();
    value = stringValue(value);
    var regex = new RegExp("^[0-9]*[.]*[0-9]*$");
    if (regex.test(value)) {
      if (value[0] !== '0') {
        return value;
      }
      else {
        if (value.length === 1) {
          return value;
        }
        else {
          if (value.length === 2) {
            if (value[0] === '0' && value[1] === '.') {
              return value;
            }
            else {
              if (value[0] === '0' && value[1] !== '.') {
                return value[1];
              }
            }
          }
          else {
            if (value.length > 2) {
              if (value.substr(2).includes('.')) {
                return value[0] + value[1];
              }
              else {
                return value;
              }
            }
          }
        }
      }
    }
    else {
      return '';
    }
  }

  return (
    <>
      {
        mode === "Features" ?
          <Grid sx={{
            display: 'flex', width: "100%", height: "100%", flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            direction: i18n.language === "fa" ? "rtl" : 'ltr', backgroundColor: "#F0D3DF",
          }}>
            <Grid sx={{
              display: 'flex', width: "70%", height: "100%", flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              direction: i18n.language === "fa" ? "rtl" : 'ltr',
            }}>
              <Grid sx={{ display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" }, marginTop: "1em" }}>
                <Grid style={{ display: "flex", alignItems: "center" }}>
                  <Autocomplete
                    value={groupSelect.find(option => option.value === oldData.group) || null}
                    onChange={onchangeGroup}
                    options={groupSelect}
                    getOptionLabel={(option) => option ? option.value || '' : ''}
                    renderOption={(props, option) => (
                      <Typography component={"li"} {...props}>
                        {option.value}
                      </Typography>
                    )}
                    size="medium"
                    sx={{
                      width: { xs: "200px", sm: "350px", md: "200px", lg: "300px", xl: "500px" }, "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
                      , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
                      , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }
                    }}
                    renderInput={(params) =>
                      <TextField
                        className="textField"
                        label="انتخاب دسته"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value) return false;
                      return option.id === value.id;
                    }}
                  />
                </Grid>
                <Grid sx={{ display: "flex", alignItems: "center", marginTop: { xs: "10px", md: "unset" } }}>
                  <Autocomplete
                    value={brandSelect.find(option => option.value === oldData.brand) || null}
                    onChange={onchangeBrand}
                    options={brandSelect}
                    getOptionLabel={(option) => option ? option.value || '' : ''}
                    renderOption={(props, option) => (
                      <Typography component={"li"} {...props}>
                        {option.value}
                      </Typography>
                    )}
                    size="medium"
                    sx={{
                      width: { xs: "200px", sm: "350px", md: "200px", lg: "300px", xl: "500px" }, "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
                      , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
                      , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }
                    }}
                    renderInput={(params) =>
                      <TextField
                        className="textField"
                        label="انتخاب برند"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value) return false;
                      return option.id === value.id;
                    }}
                  />
                </Grid>
              </Grid>
              <Grid sx={{
                display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" },
                alignItems: { xs: "center", md: "unset" }, marginTop: "20px"
              }}>
                <Grid style={{ display: "flex", alignItems: "center" }}>
                  <Autocomplete
                    value={modelSelect.find(option => option.value === oldData.model) || null}
                    onChange={onchangeModel}
                    options={modelSelect}
                    getOptionLabel={(option) => option ? option.value || '' : ''}
                    renderOption={(props, option) => (
                      <Typography component={"li"} {...props}>
                        {option.value}
                      </Typography>
                    )}
                    size="medium"
                    sx={{
                      width: { xs: "200px", sm: "350px", md: "200px", lg: "300px", xl: "500px" }, "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
                      , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
                      , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }
                    }}
                    renderInput={(params) =>
                      <TextField
                        className="textField"
                        label="انتخاب مدل"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value) return false;
                      return option.id === value.id;
                    }}
                  />
                </Grid>
                <Grid sx={{ display: "flex", alignItems: "center", marginTop: { xs: "10px", md: "unset" } }}>
                  <Autocomplete
                    value={regionSelect.find(option => option.value === oldData.region) || null}
                    onChange={onchangeRegion}
                    options={regionSelect}
                    getOptionLabel={(option) => option ? option.value || '' : ''}
                    renderOption={(props, option) => (
                      <Typography component={"li"} {...props}>
                        {option.value}
                      </Typography>
                    )}
                    size="medium"
                    sx={{
                      width: { xs: "200px", sm: "350px", md: "200px", lg: "300px", xl: "500px" }, "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
                      , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
                      , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }
                    }}
                    renderInput={(params) =>
                      <TextField
                        className="textField"
                        label="انتخاب سرزمین"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value) return false;
                      return option.id === value.id;
                    }}
                  />
                </Grid>
              </Grid>
              <Grid sx={{
                display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" },
                alignItems: { xs: "center", md: "unset" }, marginTop: "20px"
              }}>
                <Grid style={{ display: "flex", alignItems: "center" }}>
                  <Autocomplete
                    value={sizeSelect.find(option => option.value === oldData.size) || null}
                    onChange={onchangeSize}
                    options={sizeSelect}
                    getOptionLabel={(option) => option ? option.value || '' : ''}
                    renderOption={(props, option) => (
                      <Typography component={"li"} {...props}>
                        {option.value}
                      </Typography>
                    )}
                    size="medium"
                    sx={{
                      width: { xs: "200px", sm: "350px", md: "200px", lg: "300px", xl: "500px" }, "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
                      , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
                      , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }
                    }}
                    renderInput={(params) =>
                      <TextField
                        className="textField"
                        label="انتخاب سایز"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value) return false;
                      return option.id === value.id;
                    }}
                  />
                </Grid>
                <Grid sx={{ display: "flex", alignItems: "center", marginTop: { xs: "10px", md: "unset" }, }}>
                  <Autocomplete
                    value={colorSelect.find(option => option.value === oldData.color) || null}
                    onChange={onchangeColor}
                    options={colorSelect}
                    getOptionLabel={(option) => option ? option.value || '' : ''}
                    renderOption={(props, option) => (
                      <Typography component={"li"} {...props}>
                        {option.value}
                      </Typography>
                    )}
                    size="medium"
                    sx={{
                      width: { xs: "200px", sm: "350px", md: "200px", lg: "300px", xl: "500px" }, "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
                      , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
                      , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" },
                      // width: { xs: "228px", sm: "400px", md: "231px", lg: "350px", xl: "580px" },
                      // marginLeft: { xs: "1.8em", sm: "2.8em", md: "2em", lg: "3em", xl: "4.9em" }
                    }}
                    renderInput={(params) =>
                      <TextField
                        className="textField"
                        label="انتخاب رنگ"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value) return false;
                      return option.id === value.id;
                    }}
                  />
                  {/* <Typography onClick={() => openModalHandler("addColor")} sx={{ color: "#FF3951", fontWeight: "bold", paddingRight: "5px", fontSize: { xs: "8px", sm: "12px", md: "8px", lg: "12px", xl: "20px" }, cursor: "pointer" }}>افزودن +</Typography> */}
                </Grid>
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "4em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="نوع پردازنده"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.process}
                  onChange={(e) => setOldData({
                    ...oldData, process: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
                <TextField placeholder="نوع سیستم عامل"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.os}
                  onChange={(e) => setOldData({
                    ...oldData, os: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
                <TextField placeholder="شبکه های مخابراتی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.network}
                  onChange={(e) => setOldData({
                    ...oldData, network: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "1.5em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="سال معرفی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.year}
                  onChange={(e) => setOldData({
                    ...oldData, year: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
                <TextField placeholder="وزن"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.weight}
                  onChange={(e) => setOldData({
                    ...oldData, weight: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
                <TextField placeholder="تعداد سیم کارت"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.sim}
                  onChange={(e) => setOldData({
                    ...oldData, sim: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "1.5em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="فناوری صفحه نمایشگر"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.display}
                  onChange={(e) => setOldData({
                    ...oldData, display: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
                <TextField placeholder="رم"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.ram}
                  onChange={(e) => setOldData({
                    ...oldData, ram: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
                <TextField placeholder="ظرفیت داخلی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.zarfiat}
                  onChange={(e) => setOldData({
                    ...oldData, zarfiat: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "1.5em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="گرافیک"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.graphic}
                  onChange={(e) => setOldData({
                    ...oldData, graphic: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
                <TextField placeholder="رزولوشن دوربین اصلی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.mainCameraResolution}
                  onChange={(e) => setOldData({
                    ...oldData, mainCameraResolution: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
                <TextField placeholder="ویژگی های دوربین اصلی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.mainCameraFeature}
                  onChange={(e) => setOldData({
                    ...oldData, mainCameraFeature: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "1.5em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="حالت فیلم برداری دوربین اصلی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.mainCameraVideo}
                  onChange={(e) => setOldData({
                    ...oldData, mainCameraVideo: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
                <TextField placeholder="رزولوشن دوربین سلفی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.selfiCameraResolution}
                  onChange={(e) => setOldData({
                    ...oldData, selfiCameraResolution: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
                <TextField placeholder="ویژگی های دوربین سلفی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.selfiCameraFeature}
                  onChange={(e) => setOldData({
                    ...oldData, selfiCameraFeature: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "1.5em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="حالت فیلم برداری دوربین سلفی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.selfiCameraVideo}
                  onChange={(e) => setOldData({
                    ...oldData, selfiCameraVideo: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
                <TextField placeholder="باتری"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.battery}
                  onChange={(e) => setOldData({
                    ...oldData, battery: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
                <TextField placeholder="شارژ"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.charge}
                  onChange={(e) => setOldData({
                    ...oldData, charge: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "1.5em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="قیمت"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={replaceNumber(separator(oldData.price), i18n.language)}
                  onChange={(e) => setOldData({
                    ...oldData, price: onlyFloatnaumber(e.target.value)
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
                <TextField placeholder="title فارسی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.title_fa}
                  onChange={(e) => setOldData({
                    ...oldData, title_fa: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }, overflowX: "scroll"
                  }}
                />
                <TextField placeholder="title انگلیسی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.title_en}
                  onChange={(e) => setOldData({
                    ...oldData, title_en: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "1.5em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="توضیحات گوشی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.description}
                  onChange={(e) => setOldData({
                    ...oldData, description: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
                <TextField placeholder="h1 فارسی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.h1_fa}
                  onChange={(e) => setOldData({
                    ...oldData, h1_fa: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
                <TextField placeholder="h1 انگلیسی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.h1_en}
                  onChange={(e) => setOldData({
                    ...oldData, h1_en: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "1.5em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="description فارسی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.desc_fa}
                  onChange={(e) => setOldData({
                    ...oldData, desc_fa: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
                <TextField placeholder="description انگلیسی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.desc_en}
                  onChange={(e) => setOldData({
                    ...oldData, desc_en: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
                <TextField placeholder="meta-keyword فارسی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.keyword_fa}
                  onChange={(e) => setOldData({
                    ...oldData, keyword_fa: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: { xs: "20px", md: "unset" }
                  }}
                />
              </Grid>
              <Grid sx={{ marginTop: { xs: "20px", md: "1.5em" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "90%", justifyContent: { xs: "unset", md: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="meta-keyword انگلیسی"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={oldData.keyword_en}
                  onChange={(e) => setOldData({
                    ...oldData, keyword_en: e.target.value
                  })}
                  sx={{
                    width: { xs: "230px", sm: "400px", md: "30%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
              </Grid>
              <Grid sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "1em" }}>
                <Button onClick={addProduct} disabled={proDis} sx={{
                  display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "0px 2px", marginTop: "2em",
                  "&:hover": { backgroundColor: "#FF3951" }, backgroundColor: "#FF3951", width: { xs: "100px", md: "200px" }, height: { xs: "35px", md: "50px" }, borderRadius: "25px"
                }} >
                  <Typography component={"p"} sx={{ color: "white", fontSize: "17px", fontWeight: "bold" }}>
                    {proDis === true && loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : 'ویرایش'}
                  </Typography>
                </Button>
              </Grid>
            </Grid>
            <AlertMessage open={alert.alertCheck} message={alert.message} duration={3000} close={handleClose} severity={alert.severity} />
          </Grid>
          :
          <Grid sx={{
            display: 'flex', width: "100%", height: "90vh", flexDirection: 'column', alignItems: 'center',
            direction: i18n.language === "fa" ? "rtl" : 'ltr', backgroundColor: "#F0D3DF",
          }}>
            <Grid sx={{
              display: 'flex', width: "70%", flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              direction: i18n.language === "fa" ? "rtl" : 'ltr',
            }}>
              <Grid sx={{ display: "flex", width: "100%", justifyContent: "space-evenly", marginTop: "2em" }}>
                <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>{oldData.brand} {oldData.model} {oldData.color}</Typography>
              </Grid>
              <Grid sx={{ display: "flex", width: "100%", justifyContent: "space-between", marginTop: "2em" }}>
                <Grid sx={{ display: "flex", width: "35%", alignItems: "center" }}>
                  <Grid sx={{
                    width: "100%", height: "70px", borderRadius: "8px", backgroundColor: "white", border: " 0.7px solid #B9B9B9",
                    display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center", padding: "0 10px", marginTop: { xs: "20px", md: "unset" }
                  }}>
                    {
                      oldData.img1 === null ?
                        <Typography sx={{ fontSize: { xs: "12px", md: "16px" }, color: "gray" }}>ویرایش عکس 1</Typography>
                        :
                        <Typography component={'img'} src={oldData.img1} sx={{ width: "60px", height: "60px", }}></Typography>
                    }
                    <Input id="upload-photo-card1" type="file" sx={{ display: "none" }} accept="image/*"
                      onChange={(e) => onChangeLicence(e, 'IMG1')}
                    />
                    <Grid component={"label"} htmlFor="upload-photo-card1" sx={{
                      display: oldData.img1 !== null ? "none" : "flex",
                      alignItems: "center", justifyContent: "center", background: "white", borderRadius: '8px', width: { xs: "38px", md: "53px" }, height: { xs: "30px", md: "43px" }
                    }}>
                      {loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : <CloudUploadOutlinedIcon sx={{ color: "red", fontSize: { xs: "17px", md: "24px" } }} />}
                    </Grid>
                  </Grid>
                  <Button sx={{ display: oldData.img1 === null ? "none" : "flex" }} onClick={() => deleteImage("I1")} disabled={proDis}>
                    {proDis === true && loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : <DeleteRoundedIcon sx={{ color: "red", fontSize: "25px", cursor: "pointer" }} />}
                  </Button>
                </Grid>
                <Grid sx={{ display: "flex", width: "35%", alignItems: "center" }}>
                  <Grid sx={{
                    width: "100%", height: "70px", borderRadius: "8px", backgroundColor: "white", border: " 0.7px solid #B9B9B9",
                    display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center", padding: "0 10px", marginTop: { xs: "20px", md: "unset" }
                  }}>
                    {
                      oldData.img2 === null ?
                        <Typography sx={{ fontSize: { xs: "12px", md: "16px" }, color: "gray" }}>ویرایش عکس 2</Typography>
                        :
                        <Typography component={'img'} src={oldData.img2} sx={{ width: "60px", height: "60px", }}></Typography>
                    }
                    <Input id="upload-photo-card2" type="file" sx={{ display: "none" }} accept="image/*"
                      onChange={(e) => onChangeLicence(e, 'IMG2')}
                    />
                    <Grid component={"label"} htmlFor="upload-photo-card2" sx={{
                      display: oldData.img2 !== null ? "none" : "flex", alignItems: "center", justifyContent: "center",
                      background: "white", borderRadius: '8px', width: { xs: "38px", md: "53px" }, height: { xs: "30px", md: "43px" }
                    }}>
                      {loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : <CloudUploadOutlinedIcon sx={{ color: "red", fontSize: { xs: "17px", md: "24px" } }} />}
                    </Grid>
                  </Grid>
                  <Button sx={{ display: oldData.img2 === null ? "none" : "flex" }} onClick={() => deleteImage("I2")} disabled={proDis}>
                    {proDis === true && loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : <DeleteRoundedIcon sx={{ color: "red", fontSize: "25px", cursor: "pointer" }} />}
                  </Button>
                </Grid>
              </Grid>
              <Grid sx={{ display: "flex", width: "100%", justifyContent: "space-between", marginTop: "2em" }}>
                <Grid sx={{ display: "flex", width: "35%", alignItems: "center" }}>
                  <Grid sx={{
                    width: "100%", height: "70px", borderRadius: "8px", backgroundColor: "white", border: " 0.7px solid #B9B9B9",
                    display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center", padding: "0 10px", marginTop: { xs: "20px", md: "unset" }
                  }}>
                    {
                      oldData.img3 === null ?
                        <Typography sx={{ fontSize: { xs: "12px", md: "16px" }, color: "gray" }}>ویرایش عکس 3</Typography>
                        :
                        <Typography component={'img'} src={oldData.img3} sx={{ width: "60px", height: "60px", }}></Typography>
                    }
                    <Input id="upload-photo-card3" type="file" sx={{ display: "none" }} accept="image/*"
                      onChange={(e) => onChangeLicence(e, 'IMG3')}
                    />
                    <Grid component={"label"} htmlFor="upload-photo-card3" sx={{
                      display: oldData.img3 !== null ? "none" : "flex", alignItems: "center", justifyContent: "center",
                      background: "white", borderRadius: '8px', width: { xs: "38px", md: "53px" }, height: { xs: "30px", md: "43px" }
                    }}>
                      {loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : <CloudUploadOutlinedIcon sx={{ color: "red", fontSize: { xs: "17px", md: "24px" } }} />}
                    </Grid>
                  </Grid>
                  <Button sx={{ display: oldData.img3 === null ? "none" : "flex" }} onClick={() => deleteImage("I3")} disabled={proDis}>
                    {proDis === true && loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : <DeleteRoundedIcon sx={{ color: "red", fontSize: "25px", cursor: "pointer" }} />}
                  </Button>
                </Grid>
                <Grid sx={{ display: "flex", width: "35%", alignItems: "center" }}>
                  <Grid sx={{
                    width: "100%", height: "70px", borderRadius: "8px", backgroundColor: "white", border: " 0.7px solid #B9B9B9",
                    display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center", padding: "0 10px", marginTop: { xs: "20px", md: "unset" }
                  }}>
                    {
                      oldData.img4 === null ?
                        <Typography sx={{ fontSize: { xs: "12px", md: "16px" }, color: "gray" }}>ویرایش عکس 4</Typography>
                        :
                        <Typography component={'img'} src={oldData.img4} sx={{ width: "60px", height: "60px", }}></Typography>
                    }
                    <Input id="upload-photo-card4" type="file" sx={{ display: "none" }} accept="image/*"
                      onChange={(e) => onChangeLicence(e, 'IMG4')}
                    />
                    <Grid component={"label"} htmlFor="upload-photo-card4" sx={{
                      display: oldData.img4 !== null ? "none" : "flex", alignItems: "center", justifyContent: "center",
                      background: "white", borderRadius: '8px', width: { xs: "38px", md: "53px" }, height: { xs: "30px", md: "43px" }
                    }}>
                      {loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : <CloudUploadOutlinedIcon sx={{ color: "red", fontSize: { xs: "17px", md: "24px" } }} />}
                    </Grid>
                  </Grid>
                  <Button sx={{ display: oldData.img4 === null ? "none" : "flex" }} onClick={() => deleteImage("I4")} disabled={proDis}>
                    {proDis === true && loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : <DeleteRoundedIcon sx={{ color: "red", fontSize: "25px", cursor: "pointer" }} />}
                  </Button>
                </Grid>
              </Grid>
              <Grid sx={{
                bgcolor: "#FF3951", width: { xs: "50%", sm: "40%", md: "30%", lg: "25%", xl: "18%" }, height: { xs: "40px", sm: "45px", md: "50px", lg: "65px" },
                boxShadow: '#FF3951 0px 0px 15px', "&:hover": { backgroundColor: "#FF3951" },
                borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", alignSelf: "center", marginTop: "3em"
              }}>
                <NavLink to="/SorinBoard/EditProduct" className="navlink" style={{
                  display: "flex", alignItems: "center", flexDirection: "row", width: "100%", justifyContent: "center", color: "white", textAlign: "center"
                }}>
                  <Typography sx={{ fontSize: { xs: "10px", sm: "11px", md: "16px", lg: "18px", xl: "20px" }, }}>بازگشت به صفحه ویرایش</Typography>
                </NavLink>
              </Grid>
            </Grid>
          </Grid>
      }
    </>
  )
}